import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // Force le retour en haut de la page lors d'un changement d'URL
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
};

export default ScrollToTop;